import './css/bootstrap.min.css';
import './css/dataTables.bootstrap4.min.css';
import './App.css';
import $ from 'jquery'
import { Component, Fragment } from 'react';
import axios from 'axios';
import 'datatables.net'
import 'datatables.net-dt/css/jquery.dataTables.css'
import { IpoHeader, IpoFooter } from './ipo-header';

$.DataTable = require('datatables.net')
window.ipoLogin = {}
export default class Current_Issue extends Component {
  
  state = {
    data: null,
    apply_now : false,
    ipo_apply : false,
    error_msg : '',
    mobile_no : '',
    otp_code : '',
    mobile_data : {},
    is_loading : false
  }

  table;
  columns = [
    {
      data: 'symbol',
    },{
      data: 'name',
    },{
      data: 'issueType',
      autoWidth: true
    },{
      data: 'exchange',
      orderable: false,
      autoWidth: true,
      render: (data) => {
        return data.join(', ')
      }
    },{
      data: 'biddingStartDate',
      orderable: false,
      autoWidth: true
    },{
      data: 'biddingEndDate',
      autoWidth: true
    },{
      data: 'cutOffPrice',
      autoWidth: true
    },{
      data: 'lotSize',
      autoWidth: true
    },{
      data: {},
      orderable: false,
      className: 'center',
      autoWidth: true,
      render: (data) => {
        return (<a type="button" class="btn btn-info btn-sm" style={{whiteSpace: "nowrap"}} onclick="this.bidRemove(data)">Delete ' + data.symbol + '</a>); 
      }
    }
  ]

  async componentDidMount(){

    if(!this.table){
      this.table = $('#currentIssue').DataTable({
        paging: false,
        bInfo : false,
        data: [],
        columns:this.columns
      });
    }

    await axios.get('https://app.patelwealth.com/eng_ipo/api/v1/open/', {
      headers : {"Api-Key": "8f1eacab-780e-4b7e-a375-0569da25a65f", "content-type" : "application/json"}
    }).then(res => {
        const data = res.data.content;
        this.setState({data});
    });
  }

  applyNowPop(item){
    if(window.ipoLogin?.login_details){
      // const ipo_details = this.data.find(obj => obj.symbol === this.ipo_apply);
      window.ipoLogin = Object.assign({},window.ipoLogin,{'mobile_no' : this.mobile_no, 'ipo_type' : item, 'login_details' : window.ipoLogin.login_details })
      this.getUserDetails()
    }else if (item){
      this.setState({apply_now : true, ipo_apply : item.symbol});
    }

   

      
  }

  async getUserDetails(){
    if(window.ipoLogin && window.ipoLogin.login_details && window.ipoLogin.login_details.access_token){
      var config = {
        method: 'get',
        url: 'https://app.patelwealth.com/eng_middleware/api/v1/client/',
        headers: { 
          'Authorization': 'Bearer '+window.ipoLogin.login_details.access_token, 
          'content-type': 'application/json'
        }
      }
      await axios(config)
      .then(function (response) {
        if(response && response.data){
          window.ipoLogin = Object.assign({}, window.ipoLogin, {'user_details' : response.data })
          sessionStorage.setItem("ipoLogin", JSON.stringify(window.ipoLogin));
          window.location.href = 'https://'+window.location.host+'/ipo-details'
        }
      })
    }

    
  }

  async checkLogin(){
    if(this.state.is_loading === false){
      return ;
    }

    if(!this.state.mobile_no && !this.state.mobile_data.username ){
      return;
    }
    if(!this.state.mobile_no){
      this.setState({error_msg : 'Please check mobile number'});
      return;
    }
    if(!this.state.mobile_data && !this.state.mobile_data.username){
      this.setState({error_msg : 'Invalid mobine number'});
      return;
    }
    if( !this.state.otp_code){
      this.setState({error_msg : 'Enter OTP'});
      return;
    }

    if(this.state.apply_now && this.state.ipo_apply && this.state.mobile_no){
      if(this.state.mobile_data && this.state.mobile_data.username && this.state.otp_code){
        this.state.is_loading = true;
         var config = {
          method: 'post',
          url: 'https://app.patelwealth.com/eng_middleware/oauth/token?grant_type=password&username='+this.state.mobile_data.username+'&password='+this.state.otp_code,
          headers: { 
            'Authorization': 'Basic YXBwbGljYXRpb246NzczMzdCQkY0QTE5QzM2QzRCNjRBMzRCMTY0MjU=', 
            'Content-Type': 'application/x-www-form-urlencoded'
          }
        };
        let mystate = this.state,
            mythis= this
        await axios(config)
        .then(function (response) {
          if(response && response.data){
            const ipo_details = mystate.data.find(obj => obj.symbol === mystate.ipo_apply);
            window.ipoLogin = Object.assign({},window.ipoLogin,{'mobile_no' : mystate.mobile_no, 'ipo_type' : ipo_details, 'login_details' : response.data })
            mythis.getUserDetails()
          }else{
            mythis.setState({error_msg : response.error, mobile_data : {}});
            window.ipoLogin = Object.assign({},{'mobile_no' : ''})
          }
          this.state.is_loading = false;
        })
      }else{
        this.setState({error_msg : 'Please Check Mobile Number And OTP Code'});
      }
    }else{
      this.setState({error_msg : 'Select Apply IPO'});
    }
  }

  async getOTPCode(val){
    if(val.length===10){
        this.state.is_loading = true;
        this.setState({error_msg : ''});
        await axios.post('https://app.patelwealth.com/eng_middleware/api/v1/user/check/'+val, {
          headers : {"Api-Key": "8f1eacab-780e-4b7e-a375-0569da25a65f", "content-type" : "application/json"}
        }).then(res => {
            if(res && res.data){
              this.setState({mobile_no : val, mobile_data : res.data});
            }else{
              this.setState({mobile_no : '',mobile_data : {}});
            }
        });
    }
  }

  render(){
    
    return (
      <Fragment>
      <IpoHeader />
      <div className="page container mt-lg my-4">
        <div className="container">
          <div className="row">
            <div className="col-md-12 border border-light br-3 py-3">
              <h5 className='currentissue-heading text-center'>Current Issue</h5>
              <table id="currentIssue" className="table table-striped table-bordered" ref={el => this.el=el }>
                  <thead className='table-dark'>
                      <tr>
                          <th>Symbol</th>
                          <th>Company</th>
                          <th>Type</th>
                          <th>Exchange</th>
                          <th>Start date</th>
                          <th>End date</th>
                          <th className='text-center'>Price range</th>
                          <th className='text-center'>Lot Size</th>
                          <th className='text-center'>Apply</th>
                      </tr>
                  </thead>
                  <tbody>
                    { this.state.data &&
                      this.state.data.map( (item) => {
                        return (<tr key={item.name.toString()}>
                          <td className='font-weight-bold'>{item.symbol}</td>
                          <td>{item.name}</td>
                          <td>{item.issueType}</td>
                          <td>{item.exchange.join(', ')}</td>
                          <td>{item.biddingStartDate}</td>
                          <td>{item.biddingEndDate}</td>
                          <td className='text-center'>{item.cutOffPrice}</td>
                          <td className='text-center'>{item.lotSize}</td>
                          <td> {item.canApply && <button className={'btn btn-info btn-sm'} style={{whiteSpace: 'nowrap'}} onClick={() => this.applyNowPop(item)}>Apply Now</button> }</td>
                      </tr>)
                      })
                    }
                  </tbody>
              </table>
            </div>
          </div>
        </div>
        { !window.ipoLogin?.login_details && this.state.apply_now && this.state.ipo_apply &&
          <div className="modal d-block" id="modalLoginForm">
              <div className="modal-dialog" role="document">
                <div className="modal-content">
                  <div className="modal-header text-center">
                    <h4 className="modal-title w-100 font-weight-bold">Client Login</h4>
                    <button type="button" className="close" onClick={() => {this.setState({apply_now : false, ipo_apply : false, error_msg : ''}) }}>
                      <span aria-hidden="true">&times;</span>
                    </button>
                  </div>
                  {this.state.error_msg &&
                    <div className='ipo-error-msg'>{this.state.error_msg}</div>
                  }
                  <div className="modal-body mx-3">
                    <div className="md-form mb-3">
                      <label htmlFor="currentissue-email">Enter Mobile Number</label>
                      <input type="text" id="currentissue-email" placeholder="Enter Mobile Number" className="form-control validate" required maxLength="10" onChange= {(e) => this.getOTPCode(e.target.value)} />
                    </div>
                    <div className="md-form mb-3">
                      <label htmlFor="currentissue-otp">OTP Code</label>
                      <input type="text" id="currentissue-otp" placeholder="Enter OTP Code" className="form-control validate" required onChange={(e) => this.setState({otp_code : e.target.value})} />
                    </div>
                  </div>
                  {/* {this.state.mobile_data && this.state.mobile_data.username && */}
                  <div className="modal-footer d-flex justify-content-center">
                    <button className="btn btn-primary" onClick={() => this.checkLogin()}>Login</button>
                  </div>
                   {/* } */}
                </div>
              </div>
            </div>
        }
       
      </div>
      <IpoFooter />
      </Fragment>
  );
    }
}
